import { FormEditorComponent } from '../screen-editor/form-editor/form-editor.component'
import { LazyInitializerMap } from '@lg/shared/for-studio'
import type { EditorWizardDialog } from '@lg/shared'
import { Injectable, Injector, inject } from '@angular/core'
import type { BusinessObjectFilterType } from '@lg/shared'
import { EditorHelper } from './editor-helper'
// import { ScreenBlockEditorHelper, UserTaskEditorHelper } from './screen-item-editor-helper'
import {
	IconPickerComponent,
	PrefixIconPickerComponent,
} from '../screen-editor/icon-picker/icon-picker.component'
import { StudioTrpcService } from '@lg/ng-shared'
import { type AbstractEditorComponent } from '../abstract-editor.component'
import type { BusinessObject } from '@lg/shared'
import { ScreenBlockEditorHelper } from './screen-block-editor-helper'

export type EditorHelpParams = BusinessObjectFilterType

@Injectable()
export class EditorHelperService {
	private helpers = new LazyInitializerMap<
		string,
		EditorHelper | Promise<EditorHelper>
	>({
		ScreenBlock: () => this.injector.get(ScreenBlockEditorHelper),
		// loaded lazily as it depends on bpmn-js via ProcessEditorService
		'bpmn:UserTask': async () =>
			this.injector.get(
				(await import('./screen-usertask-editor-helper')).UserTaskEditorHelper,
			),
	})
	private wizardDialogs = new Map<string, EditorWizardDialog[]>()
	public params: EditorHelpParams = {} as any
	injector = inject(Injector)
	public editorComponent: AbstractEditorComponent<BusinessObject>
	constructor(public trpcService: StudioTrpcService) {
		setTimeout(async () => {
			this.wizardDialogs.set('FormBlock', [
				{
					label: 'Configure form elements',
					getDialogClass: () => FormEditorComponent,
				},
			])
			this.wizardDialogs.set('IconBlock', [
				{
					label: 'Pick icon',
					getDialogClass: () => IconPickerComponent,
				},
			])
			this.wizardDialogs.set('ButtonBlock', [
				{
					label: 'Pick prefix icon',
					getDialogClass: () => PrefixIconPickerComponent,
				},
			])
			this.wizardDialogs.set('NavigationItemBlock', [
				{
					label: 'Pick prefix icon',
					getDialogClass: () => PrefixIconPickerComponent,
				},
			])
		})
	}

	async getHelper(blockType: string) {
		return this.helpers.get(blockType)
	}

	getWizardDialogs(blockType: string) {
		return this.wizardDialogs.get(blockType) ?? []
	}
}
